import HeaderWithButton from "../Utility/HeaderWithButton";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  ExclamationCircleIcon,
  PlusCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import { v4 as uuidv4 } from "uuid";
import { Dialog } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import QuotationList from "./QuotationList";
import { DataContext } from "../../helper/HelperOne";
import TopStats from "../Utility/TopStats";
// import Loader from "../../Client/Utility/Loader";
// import InvoiceList from "./InvoiceList";
// import { DataContext } from "../../../helper/HelperOne";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import TopFilters from "../Utility/TopFilters";
import { ListCheckIcon } from "lucide-react";
import LabelTopView from "../Utility/LabelTopView";
import { DocumentChartBarIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import UpdateConfirmation from "../Utility/UpdateConfirmation";

function QuotationCreate() {
 const location = useLocation();
  const { id_crypt, showForm } = location.state || {};
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const quotationPermission = user?.quotation_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );


  const userForEdit = JSON.parse(localStorage.getItem("user"));
  const quotationPermissionForEdit =
    userForEdit?.quotation_role_based_access?.some(
      (access) => access.label_id == 3 && access.label_value != 0
    );

    const userForPdf = JSON.parse(localStorage.getItem('user'));
    const quotationPermissionForPdf= userForPdf?.quotation_role_based_access?.some(
      (access) => access.label_id == 5 && access.label_value != 0
    );

    const [filterParams, setFilterParams] = useState("");


  const { searchData } = useContext(DataContext);
  const [saveBtnOpen, setSaveBtnOpen] = useState(false);

  const [quotationInputs, setQuotationInputs] = useState({
    quotation_number: "",
    quotation_date: "",
    quotation_validity_date: "",
    quotation_status: "",
    employee_id: "",
    lead_id: "",
    terms_and_conditions: "",
    cost: "",
    tax: "",
    sub_total: "",
    total_amount: "",
    branch_id: "",
  });

  const [quotationProducts, setQuotationProducts] = useState([
    {
      product_id: "",
      product_name: "",
      quantity: "",
      price: "",
      gst: "",
      gst_amount: "",
      total_price: "",
    },
  ]);

  const [openDialogBoxForQuotation, setOpenDialogBoxForQuotation] =
    useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [branchDatas, setBranchDatas] = useState([]);
  const [saveBtn, setSaveBtn] = useState("save");
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [quotationStatusList, setQuotationStatusList] = useState([]);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [editQuotationIdCrypt, setEditQuotationIdCrypt] = useState("");
  const [quotationDatas, setQuotationDatas] = useState([]);
  const [paginationQuotationData, setPaginationQuotationData] = useState([]);
  const [customersDataList, setCustomersDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [leadAllDatas, setLeadAllDatas] = useState([]);
  const [editIdCryptForQuotation, setEditIdCryptForQuotation] = useState("");
  const [products, setProducts] = useState([]);
  const [taxDatas, setTaxDatas] = useState([]);
  const [taxAmountForGst, setTaxAmountForGst] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [quotationCounts, setQuotationCounts] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
 

  const fetchQuotationsData = async (page = 1, queryParams = "") => {
    try {
        // Merge stored filters with new filters if any
        const finalQueryParams = filterParams
            ? `${filterParams}${queryParams ? `&${queryParams}` : ""}`
            : queryParams;

        // Construct API URL with pagination and filters
        const quotationUrl = `public/api/admin/quotation/pagination?page=${page}${
            finalQueryParams ? `&${finalQueryParams}` : ""
        }${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;



        // Fetch data using Promise.all for efficiency
        const [
            quotationPaginationResponse,
            employeeResponse,
            quotationStatusResponse,
            leadResponse,
            productResponse,
            quotationResponse,
            branchResponse,
            taxResponse
        ] = await Promise.all([
            axios.get(quotationUrl, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/employees`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/quotationstatus`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/lead`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/product`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/quotation`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/branch`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
            axios.get(`public/api/admin/taxdetails`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            }),
        ]);

        setQuotationCounts(quotationPaginationResponse.data);
        setPaginationQuotationData(quotationPaginationResponse.data.quotation);
console.log(quotationPaginationResponse.data.quotation, "hello");

        setEmployeesList(employeeResponse.data.employee);
        setQuotationStatusList(quotationStatusResponse.data.quotationstatus);
        setLeadAllDatas(leadResponse.data.lead);
        setProducts(productResponse.data.products);
        setQuotationDatas(quotationResponse?.data?.quotation);
        setBranchDatas(branchResponse?.data?.branch);
        setTaxDatas(taxResponse?.data?.taxdetails);

    } catch (error) {
        console.error("Error fetching quotations data:", error);
    }
};



  useEffect(() => {
    fetchQuotationsData(currentPage);
  }, [searchData, currentPage, filterParams]);

  const [filterData, setFilterData] = useState({
    quotation_number: "",
    quotation_date: "",
    lead_id: "",
    employee_id: "",
    quotation_status: "",
  });

  const fields = [
    {
      name: "quotation_number",
      type: "text",
      placeholder: "Quotation No",
      componentType: "select",
      options: [
        ...new Set(quotationDatas?.map((quo) => quo.quotation_number)),
      ].map((value) => ({ value, label: value })),
    },
    {
      name: "quotation_date",
      type: "text",
      placeholder: "Date",
      componentType: "select",
      options: [
        ...new Set(quotationDatas?.map((quo) => quo.quotation_date)),
      ].map((value) => ({ value, label: value })),
    },
    {
      name: "lead_id",
      type: "text",
      placeholder: "Lead",
      componentType: "select",
      options: [
        ...new Set(quotationDatas?.map((quo) => quo.lead?.id)) // Correctly extract `lead.id`
      ].map((value) => ({
        value, // Pass `lead.id` as value
        label: quotationDatas.find((quo) => quo.lead?.id === value)?.lead?.name,
      })),
    },
    {
      name: "employee_id",
      type: "tel",
      placeholder: "Employee",
      componentType: "select",
      options: [...new Set(quotationDatas?.map((quo) => quo.employee?.id))].map(
        (value) => ({
          value, // Pass `employee.id` as value
          label: quotationDatas.find((quo) => quo.employee?.id === value)
            ?.employee?.name,
        })
      ),
    },
    {
      name: "quotation_status",
      type: "tel",
      placeholder: "Status",
      componentType: "select",
      options: [...new Set(paginationQuotationData?.data?.map((quo) => quo.quotation_status?.id))].map(
        (value) => ({
          value, // Pass `employee.id` as value
          label: paginationQuotationData?.data.find((quo) => quo.quotation_status?.id === value)
            ?.quotation_status?.name,
        })
      ),
    },
  ];


  const handleChangeFilterChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };



  const handleFilter = () => {
    const queryParams = new URLSearchParams();

    if (filterData.quotation_number) {
        queryParams.append("quotation_number", filterData.quotation_number);
    }
    if (filterData.quotation_date) {
        queryParams.append("quotation_date", filterData.quotation_date);
    }
    if (filterData.lead_id) {
        queryParams.append("lead_id", filterData.lead_id);
    }
    if (filterData.employee_id) {
        queryParams.append("employee_id", filterData.employee_id);
    }
    if (filterData.quotation_status) {
      queryParams.append("quotation_status", filterData.quotation_status);
  }

    const queryString = queryParams.toString();
    
    // Store the query parameters in state (to persist filters across pages)
    setFilterParams(queryString);

    // Fetch data with the new filters
    fetchQuotationsData(1, queryString);
};



const handleReset = async () => {
  setFilterData({
      quotation_number: "",
      quotation_date: "",
      lead_id: "",
      employee_id: "",
  });

  setFilterParams(""); // Reset stored filters
  await fetchQuotationsData();
};



  const taxOptions = taxDatas.map((tax) => ({
    label: `${tax.tax_name} (${tax.tax_percentage}%)`,
    value: tax.tax_percentage,
  }))
  const handleAddQuotation = async () => {
    setLoading(true);
    setIsEditing(false);
  
    const getFinancialYear = () => {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      const startYear = currentMonth < 4 ? currentYear - 1 : currentYear;
      const endYear = startYear + 1;
      return `${startYear}-${endYear}`;
    };
  
    try {
      await fetchQuotationsData();
  
      const existingNumbers = quotationDatas.map((q) =>
        Number(q.quotation_number)
      );
      const lastQuotationNumber = existingNumbers.length
        ? Math.max(...existingNumbers)
        : 99;
  
      const newQuotationNumber = lastQuotationNumber + 1;
      const quotationPrefix = `Q.No ${getFinancialYear()}`;
      setQuotationInputs({
        quotation_number: newQuotationNumber,
        quotation_prefix: quotationPrefix,
        quotation_date: new Date().toISOString().slice(0, 10),
        quotation_validity_date: "",
        quotation_status: "",
        employee_id: "",
        lead_id: "",
        terms_and_conditions: "",
        cost: "",
        tax: "",
        sub_total: "",
        total_amount: "",
        branch_id: "",
      });
      setQuotationProducts([
        {
          product_id: "",
          product_name: "",
          quantity: "",
          price: "",
          gst: "",
          gst_amount: "",
          total_price: "",
        },
      ]);
  
      setOpenDialogBoxForQuotation(true);
    } catch (error) {
      console.error("Failed to fetch quotations data", error);
    } finally {
      setLoading(false);
    }
  };
  
  
  const handleAddProducts = () => {
    setQuotationProducts((prev) => [
      ...prev,
      {
        product_id: "",
        product_name: "",
        quantity: "",
        price: "",
        gst: "",
        gst_amount: "",
        total_price: "",
      },
    ])
    
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setQuotationInputs((prev) => {
      const updatedInputs = { ...prev, [name]: value };

      const totalAmounts = quotationProducts.reduce(
        (sum, product) => sum + Number(product.total_price || 0),
        0
      );

      updatedInputs.sub_total = (totalAmounts).toFixed(2);

      if (name === "tax" || name === "sub_total" || name === "cost") {
        const subTotal = Number(updatedInputs.sub_total) || 0;
        const taxRate = Number(updatedInputs.tax) || 0;
        const taxAmount = (subTotal * taxRate) / 100;
        setTaxAmountForGst(taxAmount);
        updatedInputs.total_amount = (subTotal + taxAmount).toFixed(2);

      }

      return updatedInputs;
    });
  };




  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
  
    if (name === "product_id") {
      const selectedProduct = products.find((product) => product.id == value);
  
      setQuotationProducts((prevProducts) => {
        const updatedProducts = [...prevProducts];
        updatedProducts[index] = {
          ...updatedProducts[index],
          product_name: selectedProduct.product_name,
          price: selectedProduct.product_cost,
        };
        return updatedProducts;
      });
    }
  
    setQuotationProducts((prevProducts) => {
      let updatedProducts = prevProducts.map((product, i) => {
        if (i !== index) return product;
  
        let newValue = value;
        if (name === "quantity" || name === "gst") {
          newValue = value ? parseFloat(value) : 0;
        }
  
        const updatedProduct = { ...product, [name]: newValue };
        const rateValue = parseFloat(updatedProduct.price) || 0;
        const quantityValue = parseFloat(updatedProduct.quantity) || 0;
        const gstValue = parseFloat(updatedProduct.gst) || 0;
  
        if (rateValue > 0 && quantityValue > 0) {
          const gstAmount = (rateValue * quantityValue * gstValue) / 100;
          updatedProduct.gst_amount = gstAmount.toFixed(2);
          updatedProduct.total_price = (rateValue * quantityValue + gstAmount).toFixed(2);
        }
  
        return updatedProduct;
      });
  
      updateQuotationInputs(updatedProducts);
  
      return updatedProducts;
    });
  };
  
  const updateQuotationInputs = (products) => {

    const subTotalAmount = products.reduce(
      (sum, product) => sum + (parseFloat(product.price || 0) * parseFloat(product.quantity || 0)),
      0
    );
 
    const totalGstAmount = products.reduce(
      (sum, product) => sum + (parseFloat(product.gst_amount) || 0),
      0
    );
  
    setQuotationInputs((prev) => {
      const cost = Number(prev.cost) || 0;
      const subTotal = (cost + subTotalAmount).toFixed(2); 
  
      const taxRate = Number(prev.tax) || 0;
      const taxAmount = (subTotal * taxRate) / 100; 
      setTaxAmountForGst(taxAmount);
      setCgst(totalGstAmount / 2);
      setSgst(totalGstAmount / 2); 

  
      const overallTotal = (Number(subTotal) + totalGstAmount).toFixed(2); 
  
      return {
        ...prev,
        sub_total: subTotal,
        total_amount: overallTotal, 
      };
    });
  };

  

  const handleRemoveProduct = (index) => {
    setQuotationProducts((prevProducts) => {
      const updatedProducts = prevProducts.filter((_, i) => i !== index);
      updateQuotationInputs(updatedProducts);
      return updatedProducts;
    });
  };

  const handleSubmitForQuotation = async (e) => {
    e.preventDefault();
    const merged = {
      ...quotationInputs,
      quotation_products: quotationProducts,
    };


    try {
      const response = await axios.post(
        "public/api/admin/quotation/store",
        merged, 
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setOpenDialogBoxForQuotation(false);
      await fetchQuotationsData();
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleEditForQuotation = async (id_crypt) => {
    setIsEditing(false);
    toast.success("Now You Can Edit This Lead");
    setSaveBtnOpen(true);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/quotation/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );


      setQuotationInputs({
        quotation_number: response.data.quotation.quotation_number,
        quotation_date: response.data.quotation.quotation_date,
        quotation_validity_date:
          response.data.quotation.quotation_validity_date,
        quotation_status: response.data.quotation.quotation_status,
        employee_id: Number(response.data.quotation.employee?.id),
        lead_id: response.data.quotation.lead?.id,
        terms_and_conditions: response.data.quotation.terms_and_conditions,
        cost: response.data.quotation.cost,
        tax: response.data.quotation.tax,
        sub_total: response.data.quotation.sub_total,
        total_amount: response.data.quotation.total_amount,
        branch_id: response.data.quotation.branch_id,
      });
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePdfForQuotation = async (id_crypt) => {
  

    setIsEditing(true);

    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `public/api/admin/quotation/pdf/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", 
        }
      );

    

      if (!response.data || response.data.size === 0) {
        throw new Error("Received empty PDF data.");
      }

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("download", "dreams.pdf"); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(pdfUrl);

      toast.success("PDF downloaded successfully!");
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
      } else {
        console.error("Error:", error);
        toast.error(
          error.message || "Something went wrong while downloading the PDF."
        );
      }
    } finally {
      setIsEditing(false);
    }
  };


  const handleUpdateForQuotation = async (e) => {
    e.preventDefault();
    const merged = {
      ...quotationInputs,
      quotation_products: quotationProducts,
    };


    try {
      const response = await axios.put(
        `public/api/admin/quotation/update/${editIdCryptForQuotation}`,
        merged,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if(response.data){
        await fetchQuotationsData();
        toast.success(response.data.message);
        setOpenDialogBoxForQuotation(false);
        setIsDialogOpen(false);
      }
     
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleDialogClose = async () => {
    setLoading(true);
    try {
      await fetchQuotationsData();
      setOpenDialogBoxForQuotation(false);
      if (showForm) {
        navigate('/crm/lead_dashboard'); 
    } else {
        navigate(location.pathname, {
            state: { ...location.state, showForm: false }
        });
    }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const statsFieldNames = [
    {
      title: "Total",
      value: paginationQuotationData.data?.length,
      color: "blue",
      bg: "bg-teal-50",
      link: "/crm/employees",
    },
    {
      title: "Approved",
      value: quotationCounts?.approvedCounts,
      color: "green",
      bg: "bg-green-50",
      link: "/crm/employees/active",
    },
    {
      title: "Pending",
      value: quotationCounts?.pendingCounts,
      color: "indigo",
      bg: "bg-indigo-50",
      link: "/crm/employees/inactive",
    },
    {
      title: "In Progress",
      value: quotationCounts?.inprogressCounts,
      color: "yellow",
      bg: "bg-yellow-50",
      link: "/crm/employees/inactive",
    },
    {
      title: "Rejected",
      value: quotationCounts?.rejectedCounts,
      color: "red",
      bg: "bg-red-50",
      link: "/crm/employees/inactive",
    },
    {
      title: "This Month",
      value: quotationCounts?.currentMonthQuotationCount,
      color: "blue",
      bg: "bg-purple-50",
      link: "/crm/employees/inactive",
    },
  ];

  const openDialogUpdateConfirmation = (e) => {
    e.preventDefault();
    setIsDialogOpen(true);
  };

  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        <>
          <LabelTopView label="Quotation Overview" icon={<ListCheckIcon />} />

<TopStats statsFieldNames={statsFieldNames} />
          <HeaderWithButton
            title="Quotation"
            description="quotation"
            buttonText="Quotation"
            onButtonClick={handleAddQuotation}
            showButton={quotationPermission}
          />

          <TopFilters
            fields={fields}
            filterData={filterData}
            handleChange={handleChangeFilterChange}
            handleFilter={handleFilter}
            handleReset={handleReset}
          />

          <QuotationList
            fetchQuotationsData={fetchQuotationsData}
            setLoading={setLoading}
            setEditIdCryptForQuotation={setEditIdCryptForQuotation}
            setOpenDialogBoxForQuotation={setOpenDialogBoxForQuotation}
            quotationDatas={quotationDatas}
            setIsEditing={setIsEditing}
            setQuotationInputs={setQuotationInputs}
            setQuotationProducts={setQuotationProducts}
            setCurrentPage={setCurrentPage}
            paginationQuotationData={paginationQuotationData}
            id_crypt={id_crypt} 
            showForm={showForm}
            setCgst={setCgst}
            setSgst={setSgst}
            filterParams={filterParams}
            setSaveBtn={setSaveBtn}
            setSaveBtnOpen={setSaveBtnOpen}
          />

          {openDialogBoxForQuotation && (
            <Dialog
              open={openDialogBoxForQuotation}
              onClose={setOpenDialogBoxForQuotation}
              className="relative z-10"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 md:max-w-screen-xl lg:max-w-screen-xl sm:w-full">
                    <div
                      className="flex justify-between p-4 text-white sticky top-0"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-mediumuppercase">
                        Quotation
                      </h1>
                      <div className="flex items-center gap-3">
                        {quotationPermissionForEdit && isEditing && (
                          <div className="flex items-center gap-3">
                            <PencilSquareIcon
                              onClick={() => {
                                handleEditForQuotation(editIdCryptForQuotation);
                                setIsOpenEdit(false);
                              }}
                              className="h-6 w-6 cursor-pointer text-white"
                              data-tooltip-id="edit-tooltip"
                              data-tooltip-content="Edit Quotation"
                            />

                            <DocumentChartBarIcon
                              onClick={() => {
                                handlePdfForQuotation(editIdCryptForQuotation);
                                setIsOpenEdit(false);
                              }}
                              className="h-6 w-6 cursor-pointer text-white"
                              data-tooltip-id="pdf-tooltip"
                              data-tooltip-content="Download PDF"
                            />
                          </div>
                        )}

                        <div>
                          <XMarkIcon
                            onClick={handleDialogClose}
                            className="h-6 w-6 cursor-pointer"
                            data-tooltip-id="close-tooltip"
                            data-tooltip-content="Close"
                          />
                        </div>

                        {/* Tooltip Definitions */}
                        <Tooltip
                          id="close-tooltip"
                          place="top"
                          effect="solid"
                        />
                        <Tooltip id="edit-tooltip" place="top" effect="solid" />
                        <Tooltip id="pdf-tooltip" place="top" effect="solid" />
                      </div>
                    </div>

                    <div className="md:grid md:gap-6 p-4">
                      <div className="md:mt-0 md:col-span-2">
                        <form>
                          <div className=" overflow-hidden">
                            <div className="p-6">
                              <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                {/* Manual Type Input (1/3 on Medium, 1/6 on Large) */}
                                <div className="col-span-1 sm:col-span-1 lg:col-span-1">
                                  <label className="block  text-md font-medium text-gray-900">
                                    Quotation No
                                  </label>
                                  <input
                                    name="quotation_number"
                                    type="text"
                                    value={quotationInputs.quotation_number}
                                    onChange={handleChange}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md  border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="Quotation No"
                                  />
                                </div>

                                <div className="col-span-1 sm:col-span-1 lg:col-span-1">
                                  <label
                                    htmlFor="invoice_number"
                                    className="block  text-md font-medium text-gray-700"
                                  >
                                    quotation date
                                  </label>
                                  <input
                                    name="quotation_date"
                                    type="date"
                                    value={quotationInputs.quotation_date}
                                    onChange={handleChange}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md  border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                </div>

                                <div className="col-span-1 sm:col-span-1 lg:col-span-1">
                                  <label className="block  text-md font-medium text-gray-900">
                                    Branch
                                  </label>
                                  {/* <input
                                    name="branch_id"
                                    type="text"
                                    value={quotationInputs.branch_id}
                                    onChange={handleChange}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md uppercase border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="Bill Id"
                                  /> */}
                                   <Select
                                    name="branch_id"
                                    options={branchDatas?.map(
                                      (branch) => ({
                                        value: branch.id,
                                        label: branch.branch_name,
                                      })
                                    )}
                                    value={
                                      branchDatas
                                        ?.filter(
                                          (branch) =>
                                            Number(branch.id) ===
                                          Number(quotationInputs?.branch_id)
                                        )
                                        ?.map((branches) => ({
                                          value: branches.id,
                                          label: branches.branch_name,
                                        })) || null
                                    }

                                   
                                    onChange={(selectedOption) =>
                                      handleChange({
                                        target: {
                                          name: "branch_id",
                                          value: selectedOption?.value,
                                        },
                                      })
                                    }
                                    className="w-full mt-2"
                                    isDisabled={isEditing}
                                    classNamePrefix="select"
                                  />
                                </div>

                                {/* Customer/Dealer Selection (2/3 on Medium, 2/6 on Large) */}

                                {/* Branch Input (1/3 on Medium, 1/6 on Large) */}

                                {/* Service Name Input (2/3 on Medium, 2/6 on Large) */}
                                <div className="col-span-1 sm:col-span-2 md:col-span-1 lg:col-span-1">
                                  <label className="block  text-md font-medium text-gray-900">
                                    Valid Date
                                  </label>
                                  <input
                                    name="quotation_validity_date"
                                    type="date"
                                    value={
                                      quotationInputs.quotation_validity_date
                                    }
                                    onChange={handleChange}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md  border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                </div>

                                {/* <div className="col-span-1 sm:col-span-2 md:col-span-1 lg:col-span-1">
                                  <label className="block uppercase text-md font-medium text-gray-900">
                                    Cost
                                  </label>
                                  <input
                                    name="cost"
                                    type="text"
                                    value={quotationInputs.cost}
                                    onChange={handleChange}
                                    placeholder="Cost"
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    }  mt-2 rounded-md uppercase border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                </div> */}
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 mt-5">
                                {/* Invoice Number */}

                                <div className="col-span-1 sm:col-span-1 lg:col-span-1">
                                  <label className="block  text-md font-medium text-gray-900">
                                    Status
                                  </label>

                                  <Select
                                    name="quotation_status"
                                    options={quotationStatusList?.map(
                                      (quotationstatus) => ({
                                        value: quotationstatus.id,
                                        label: quotationstatus.name,
                                      })
                                    )}
                                    value={
                                      quotationStatusList
                                        ?.filter(
                                          (quotationstatus) =>
                                            Number(quotationstatus.id) ===
                                          Number(quotationInputs?.quotation_status)
                                        )
                                        ?.map((quotationstatus) => ({
                                          value: quotationstatus.id,
                                          label: quotationstatus.name,
                                        })) || null
                                    }

                                   
                                    onChange={(selectedOption) =>
                                      handleChange({
                                        target: {
                                          name: "quotation_status",
                                          value: selectedOption?.value,
                                        },
                                      })
                                    }
                                    className="w-full mt-2"
                                    isDisabled={isEditing}
                                    classNamePrefix="select"
                                  />
                                </div>

                                <div className="col-span-1 sm:col-span-2 lg:col-span-2">
                                  <div className="w-full">
                                    <label
                                      htmlFor="employee_id"
                                      className="block  text-md font-medium leading-6 text-gray-900"
                                    >
                                      Employees
                                    </label>

                                    <Select
                                      name="employee_id"
                                      options={employeesList?.map(
                                        (employee) => ({
                                          value: employee.id,
                                          label: employee.name,
                                        })
                                      )}
                                      value={
                                        employeesList
                                          ?.filter(
                                            (employee) =>
                                              employee.id ===
                                              quotationInputs?.employee_id
                                          )
                                          ?.map((employee) => ({
                                            value: employee.id,
                                            label: employee.name,
                                          })) || null
                                      }
                                      onChange={(selectedOption) =>
                                        handleChange({
                                          target: {
                                            name: "employee_id",
                                            value: selectedOption?.value,
                                          },
                                        })
                                      }
                                      className="w-full mt-2 "
                                      isDisabled={isEditing}
                                      classNamePrefix="select"
                                      placeholder="Select Lead"
                                    />

                                    {/* <Select
                                      
                                      name="employee_id"
                                      options={employeesList?.map(
                                        (employee) => ({
                                          value: employee.id,
                                          label: employee.name,
                                        })
                                      )} // Convert employee list to react-select format
                                      // value={employeesList
                                      //   .filter((employee) =>
                                      //     quotationInputs?.employee_id?.includes(
                                      //       employee.id
                                      //     )
                                      //   )
                                      //   .map((employee) => ({
                                      //     value: employee.id,
                                      //     label: employee.name,
                                      //   }))}
                                      onChange={(selectedOptions) => {
                                        handleChange({
                                          target: {
                                            name: "employee_id",
                                            value: selectedOptions?.value
                                            // selectedOptions?.map(
                                            //   (option) => option?.value
                                            // ),
                                          },
                                        });
                                      }}

                                      // onChange={(selectedOption) =>
                                      //   handleChange({
                                      //     target: {
                                      //       name: "lead_id",
                                      //       value: selectedOption?.value,
                                      //     },
                                      //   })
                                      // }

                                      className="w-full mt-2 uppercase"
                                      classNamePrefix="select"
                                      isDisabled={isEditing}
                                    /> */}

                                    {/* {requiredFields.employees_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.employees_id}
                                    </p>
                                  )} */}
                                  </div>
                                </div>

                                <div className="col-span-1 sm:col-span-2 lg:col-span-2">
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                                    <label className="block  text-md font-medium text-gray-900">
                                      Lead
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <Select
                                      name="lead_id"
                                      options={leadAllDatas?.map((lead) => ({
                                        value: lead.id,
                                        label: lead.name,
                                      }))}
                                      value={
                                        leadAllDatas
                                          ?.filter(
                                            (lead) =>
                                              lead.id ===
                                              quotationInputs?.lead_id
                                          )
                                          ?.map((lead) => ({
                                            value: lead.id,
                                            label: lead.name,
                                          })) || null
                                      }
                                      onChange={(selectedOption) =>
                                        handleChange({
                                          target: {
                                            name: "lead_id",
                                            value: selectedOption?.value,
                                          },
                                        })
                                      }
                                      className="w-full mt-2 "
                                      isDisabled={isEditing}
                                      classNamePrefix="select"
                                      placeholder="Select Lead"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Add Products */}
                              <div className="grid grid-cols-6 gap-6 mt-5">
                                <div className="col-span-6">
                                  <div className="flex items-center space-x-2">
                                    <label
                                      htmlFor="end_date"
                                      className="block uppercase text-md font-medium leading-6 text-gray-900"
                                    >
                                      Add Products
                                    </label>
                                    {/*<PlusCircleIcon
                                      className="h-5 w-5 text-blue-500 cursor-pointer"
                                      onClick={handleAddProducts}
                                      
                                    />}*/}
                                    <PlusCircleIcon
  className={`h-5 w-5 cursor-pointer ${isEditing ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'}`}
  onClick={!isEditing ? handleAddProducts : undefined}
/>

                                  </div>

                                  {/* Horizontal scroll for the product input fields */}
                                  <div className="max-w-full overflow-x-auto mt-5">
                                    {/* Header Row */}
                                    <div className="grid grid-cols-12 gap-4 bg-gray-100 p-2 rounded-md border-b min-w-[1200px]">
                                      <div className="col-span-2  text-md font-medium text-gray-900 text-center">
                                        Choose Product
                                      </div>
                                      <div className="col-span-2  text-md font-medium text-gray-900 text-center">
                                        price
                                      </div>
                                      <div className="col-span-1  text-md font-medium text-gray-900 text-center">
                                        Quantity
                                      </div>
                                      <div className="col-span-2  text-md font-medium text-gray-900 text-center">
                                        GST%
                                      </div>
                                      <div className="col-span-2  text-md font-medium text-gray-900 text-center">
                                        GST AMOUNT
                                      </div>
                                      <div className="col-span-2  text-md font-medium text-gray-900 text-center">
                                        Total ₹
                                      </div>
                                    </div>

                                    {/* Product Rows */}
                                    {Array.isArray(quotationProducts) &&
                                      quotationProducts?.map(
                                        (product, index) => (
                                          <div
                                            key={index}
                                            className="grid grid-cols-12 gap-4 items-center border-b py-2 min-w-[1200px]"
                                          >
                                            {/* Choose Product (Dropdown) */}
                                            <div className="col-span-2">
                                              {/* <input
                                                type="text"
                                                name="product_name"
                                                value={product.product_name}
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                                className="mt-1 uppercase text-md block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md "
                                                placeholder="Product"
                                                disabled={isEditing}
                                              /> */}
                                              <select
                                                name="product_id"
                                                value={product.product_id}
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                                className="mt-1  text-md block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md"
                                                disabled={isEditing}
                                              >
                                                <option value="">
                                                  Select a product
                                                </option>
                                                {products.map((prod, idx) => (
                                                  <option
                                                    key={idx}
                                                    value={prod.id}
                                                  >
                                                    {prod.product_name}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>

                                            {/* Rate (Input Field) */}
                                            <div className="col-span-2 w-full">
                                              <input
                                                type="text"
                                                name="price"
                                                value={product.price}
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                                className="mt-1  text-md block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md "
                                                placeholder="Price"
                                                disabled={isEditing}
                                              />
                                            </div>

                                            {/* Quantity (Input Field) */}
                                            <div className="col-span-1 w-full">
                                              <input
                                                type="text"
                                                name="quantity"
                                                value={product.quantity}
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                                className="mt-1  text-md block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md"
                                                placeholder="Quantity"
                                                disabled={isEditing}
                                              />
                                            </div>

                                            {/* Tax (Dropdown) */}
                                            <div className="col-span-2">
                                              <select
                                                className="border border-gray-300 rounded-md px-2 py-1"
                                                value={product.gst}
                                                disabled={isEditing}
                                                name="gst"
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                              >
                                                <option value="">
                                                  Select Tax
                                                </option>
                                                {taxOptions.map(
                                                  (tax, index) => (
                                                    <option
                                                      key={index}
                                                      value={tax.value}
                                                    >
                                                      {tax.label}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </div>

                                            {/* Discount (Input Field) */}
                                            <div className="col-span-2">
                                              <input
                                                type="text"
                                                name="gst_amount"
                                                value={product.gst_amount}
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                                className="mt-1  text-md  block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md"
                                                disabled={isEditing}
                                              />
                                            </div>

                                            {/* Total Cost (Input Field) */}
                                            <div className="col-span-2">
                                              <input
                                                type="text"
                                                name="total_price"
                                                value={product.total_price}
                                                className="mt-1 uppercase text-md block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md "
                                                onChange={(e) =>
                                                  handleInputChange(e, index)
                                                }
                                                disabled={isEditing}
                                              />
                                            </div>

                                            {/* Remove Button */}
                                            <div className="col-span-1 flex justify-end">
                                              <XCircleIcon
                                                className="h-6 w-6 text-red-500 mt-3 cursor-pointer hover:text-red-600 hover:scale-105 transition-all duration-200 ease-in-out transform"
                                                onClick={() =>
                                                  handleRemoveProduct(index)
                                                }
                                                disabled={isEditing}
                                              />
                                            </div>
                                          </div>
                                        )
                                      )}

                                    {/* Summary Section */}
                                    <div className="flex justify-end mt-4 min-w-[1200px]">
                                      <div className="w-1/3 bg-gray-100 p-4 rounded-md">
                                        <div className="flex justify-between text-md font-medium text-gray-900">
                                          <span>Subtotal:</span>
                                          <span>
                                            <input
                                              type="text"
                                              name="sub_total"
                                              value={quotationInputs.sub_total}
                                              onChange={handleInputChange}
                                              className="border border-gray-300 rounded-md px-2 py-1"
                                              disabled={isEditing}
                                            />
                                          </span>
                                        </div>
                                        {/* <div className="flex justify-between text-md font-medium text-gray-900 mt-2">
                                          <span>Tax:</span>
                                          <select
                                            className="border border-gray-300 rounded-md px-2 py-1"
                                            name="tax"
                                            value={quotationInputs.tax}
                                            disabled={isEditing}
                                            onChange={handleChange}
                                          >
                                            <option value="">Select Tax</option>
                                            {taxOptions.map((tax, index) => (
                                              <option
                                                key={index}
                                                value={tax.value}
                                              >
                                                {tax.label}
                                              </option>
                                            ))}
                                          </select>
                                        </div> */}
                                        <div className="flex justify-evenly text-md font-medium text-gray-900 mt-2">
                                          {/* <span>SGST: ₹ {taxAmountForGst/2}</span>
                                          <span>CGST:₹ {taxAmountForGst/2}</span> */}

<span>CGST: ₹ {cgst}</span>
<span>SGST: ₹ {sgst}</span>
                                        
                                        </div>
                                       
                                        
                                        <div className="flex justify-between text-lg font-semibold text-gray-900 mt-2 border-t pt-2">
                                          <span>Total:</span>
                                          <span>
                                            <input
                                              type="text"
                                              name="total_amount"
                                              value={
                                                quotationInputs.total_amount
                                              }
                                              onChange={handleChange}
                                              className="border border-gray-300 rounded-md px-2 py-1"
                                              disabled={isEditing}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="grid grid-cols-1 gap-6 mt-5">
                                <div className="col-span-8 sm:col-span-8 lg:col-span-2">
                                  <label
                                    // htmlFor="start_date"
                                    className="block  text-md font-medium leading-6 text-gray-900"
                                  >
                                    Terms and Conditions
                                  </label>
                                  <div className="mt-2">
                                    <textarea
                                      rows={3}
                                      name="terms_and_conditions"
                                      value={
                                        quotationInputs.terms_and_conditions ||
                                        ""
                                      }
                                      onChange={handleChange}
                                      placeholder="Terms Conditions"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md  border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Save Button */}
                              {/* {saveBtn === "save" ? (
                                <div className="bg-white mt-6">
                                  <button
                                    onClick={(e) => handleSubmitForQuotation(e)}
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                <div className="bg-white mt-6">
                                  <button
                                    onClick={(e) => handleUpdateForQuotation(e)}
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                </div>

                              )} */}

<div className="flex justify-end">
                              {saveBtn === "save" ? (
                                <div className="bg-white mt-6">
                                  <button
                                    onClick={(e) => handleSubmitForQuotation(e)}
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                <div className="bg-white mt-6">
                                  <button
                                    // onClick={(e) => handleUpdateForQuotation(e)}
                                    onClick={(e)=>openDialogUpdateConfirmation(e)}
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                  {/* <UpdateConfirmation
                                    id_crypt={editIdCryptForQuotation}
                                    apiType="quotation"
                                    fetchClientData={fetchQuotationsData}
                                    inputs={quotationInputs}
                                    dialogClose={setOpenDialogBoxForQuotation}
                                  /> */}
                                </div>
                              )}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}



<Dialog open={isDialogOpen}
 onClose={()=>{}} 
 className="relative z-50">
      {/* Background Overlay */}
      <div className="fixed inset-0 bg-gray-800 bg-opacity-75" aria-hidden="true" />

      {/* Dialog Content */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
          <Dialog.Title className="text-lg font-bold text-gray-800">
            Update Confirmation
          </Dialog.Title>

          <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
            <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
              <span className="flex items-center justify-center p-2 rounded-full bg-blue-100">
                <ExclamationCircleIcon className="h-6 w-6 text-blue-600" />
              </span>
              <div className="text-center sm:text-left mt-3 sm:mt-0">
                <p className="text-gray-600">
                  Are you sure you want to update this item?
                </p>
              </div>
            </div>
          </div>

          {/* Button Controls */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
            <button
              onClick={()=>setIsDialogOpen(false)}
              className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={(e) => handleUpdateForQuotation(e)}
              className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Update
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
        </>
      )}
    </>
  );
}

export default QuotationCreate;
